<template>
  <div class="dialog-mask warn-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div class="dialog-header">{{ 'warning' | lang }}</div>
      <div class="dialog-body">
        <p>{{ 'cartShippingWarnAddress' | lang }}</p>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(true)">{{ 'Close' | lang }}</button>
        <button @click="checkFullLoginAndGoTo('/account'); sweetClose(true);">{{ 'goToProfile' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'
import routeControl from '@/mixins/routeControl'
export default {
  name: 'WarnIndirizzoDiSpedizione',
  mixins: [ dialogMixin,routeControl ],
  computed: {
  
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

$dett_sto_width: 25rem;
.warn-dialog .dialog-content {
  min-width: $dett_sto_width;
      width: $dett_sto_width;
  max-width: $dett_sto_width;
}
#app.mobile .warn-dialog .dialog-content {
  min-width: calc(100vw - 2rem);
      width: calc(100vw - 2rem);
  max-width: calc(100vw - 2rem);
}

</style>
